import { render, staticRenderFns } from "./PrintBillForm.vue?vue&type=template&id=13c6f23e&"
import script from "./PrintBillForm.vue?vue&type=script&lang=js&"
export * from "./PrintBillForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports